import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useModal } from '@composables/useModal';

const useInvoiceModalStore = defineStore('invoiceModal', () => {
  const { isOpen, closeModal, openModal } = useModal();
  const componentName = ref(null);
  const title = ref(null);
  const details = ref(null);

  const setTitle = (modalTitle) => {
    title.value = modalTitle;
  };

  const setDetails = (modalDetails) => {
    details.value = modalDetails;
  };

  const setModal = ({ modalTitle, modalComponentName, shouldOpenModal = false }) => {
    title.value = modalTitle;
    componentName.value = modalComponentName;

    if (shouldOpenModal) {
      openModal();
    }
  };

  const reset = () => {
    componentName.value = null;
    title.value = null;
    details.value = null;
  };

  return {
    isOpen,
    closeModal,
    openModal,
    title,
    componentName,
    details,
    setTitle,
    setModal,
    setDetails,
    reset,
  };
});

export default useInvoiceModalStore;
